export var RefundableState;
(function (RefundableState) {
    RefundableState["REFUNDABLE"] = "Refundable";
    RefundableState["NON_REFUNDABLE"] = "Non-Refundable";
    RefundableState["PARTIALLY_REFUNDABLE"] = "Partially Refundable";
})(RefundableState || (RefundableState = {}));
//# sourceMappingURL=RefundableState.js.map